import { getSeedingProposalRejectionReasons as getSeedingProposalRejectionReasonsApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetSeedingProposalRejectionReasonsServiceResponse } from './get-seeding-proposal-rejection-reasons.dto';
import { GetSeedingProposalRejectionReasonsServiceResponseSchema } from './get-seeding-proposal-rejection-reasons.dto';

export const getSeedingProposalRejectionReasonsService = withServiceErrorCapture(
  lazyPipe(async (): Promise<GetSeedingProposalRejectionReasonsServiceResponse> => {
    const apiResponse = await getSeedingProposalRejectionReasonsApi();

    if (apiResponse.meta?.result === 'FAIL') {
      throw new Error(apiResponse.meta?.message ?? '거절 사유 조회에 실패했습니다.');
    }
    return apiResponse.data;
  }, validateServiceResponse(GetSeedingProposalRejectionReasonsServiceResponseSchema)),
);
